import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "../shared/contexts/AuthContext";
import { LanguageProvider } from "../shared/i18n";
import { TabSwitchProvider } from "../layouts/TabSwitchContext";
import OnboardingExitLayer from "../features/onboarding/OnboardingExitLayer";
import OnboardingSheetGate from "../features/onboarding/OnboardingSheetGate";
import AppRouter from "./router";
import "./App.css";

export default function App() {
  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <TabSwitchProvider>
            <OnboardingExitLayer />
            <OnboardingSheetGate />
            <AppRouter />
          </TabSwitchProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
}
